import {writable} from "svelte/store";
const journalWorkoutsStore = writable<Array<any>>([]);
export {journalWorkoutsStore};
